<style>
  .paragrapghHead {
    font-size: 15px;
    color: black;
    font-weight: 500;
    font-family: Plus Jakarta Sans;
    box-sizing: border-box;
    text-align: center;
    margin-top: 15px;
    line-height: 22px;
    padding: 15px;
  }

  .paragrapghBody {
    font-size: 14px;
    margin-top: 25px;
    /* margin-left: 33%; */
    line-height: 30px;
    margin-bottom: 1rem;
    box-sizing: border-box;
    font-family: Plus Jakarta Sans;
  }

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn {
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #08ba9c;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    line-height: 20.16px;
  }
  .card{
    border:1px solid #08BA9C ;
  }
  .bg-green{
    padding: 10px;
    background-color:#ECFFEE;
  }
</style>
<div class="container-fluid pn intro_box_bg_banner">
  <div class="container">
    <div class="col-12">
      <div class="bg-green">
      <div class="card">
        <div class="header" style="min-height: 660px">
          <img src="/assets/images/notforphone.svg" alt="notforphone"  style="width: 103.36px; height: 103.03px;" class="mt-5"/>
          <h4 class="title paragrapghHead mt-4">
            You will not be able to use this tool on the mobile device. Please
            use laptop or computer.
          </h4>
          <p class="category paragrapghBody">
            <a (click)="redirectToLogin()">
              <button
                type="button"
                class="btn btn-light rounded py-2 m-0 px-0"
                style="width: 160px; height: 46px"
              >
                Take me Home                
              </button>
            </a>            
          </p>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>
